import { useState } from "react";
import { IPFilter } from "../../../core/api/organizations/types";
import { notify } from "../../../ui-lib/components/Alerts/Toast";
import { notifyApiErrors } from "../../../core/helpers/helpers";
import { putResellerIP } from "../../../core/api/sellers/sellers";
import { AddEditIPForm } from "../../../components/AddEditIPForm";

import useTranslations from "../../../core/i18n/useTranslations";
import useUser from "../../../core/user/useUser";

export const CreateEditResellerIPModal = ({
  sellerId,
  onClose,
  isOpen,
  defaultValues,
  filters,
}: {
  sellerId: number;
  onClose: (reload?: boolean) => void;
  isOpen: boolean;
  defaultValues?: IPFilter;
  filters?: IPFilter[];
}) => {
  const t = useTranslations();
  const { authenticatedRequest } = useUser();

  const [isLoading, setIsLoading] = useState(false);
  const updating = !!defaultValues;

  const onSubmit = async (values: IPFilter) => {
    setIsLoading(true);
    let updatedIpList: IPFilter[] = [];

    if (updating) {
      updatedIpList =
        filters?.map((item) => (item.id === values.id ? values : item)) || [];
    }

    const filtersData = () => {
      if (updating) {
        return updatedIpList;
      }
      if (filters?.length) {
        return [...filters, values];
      }
      return [values];
    };
    try {
      await putResellerIP(sellerId, authenticatedRequest, {
        filters: filtersData(),
      });
      onClose(true);
      notify({
        message: t(
          `AlarmReceptions:ip_${defaultValues ? "edit" : "create"}_success`,
        ),
      });
    } catch (error: any) {
      notifyApiErrors(error.response?.data?.errors);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AddEditIPForm
      defaultValues={defaultValues}
      withOrgFilter={false}
      parentId={sellerId.toString()}
      isOpen={isOpen}
      isLoading={isLoading}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
};
